import './styles.styl';
import './403';
import { setupTheme } from 'base/global/theme';

setupTheme();